<script>
export default {
  name: 'TagsList',
  props: {
    tags: { type: Array, required: true },
    title: { type: String, required: true },
  },
  computed: {
    tagsList() {
      return (this.tags || [])
        .reduce((list, tag) => list + ', ' + (tag.name || tag.text), '')
        .substring(2)
    },
  },
}
</script>

<template>
  <dl class="m-0 p-0 flex flex-column post-causes-tags leading-normal">
    <dt class="inline-block mr-2">{{ title }}:</dt>
    <dd class="inline-block">
      {{ tagsList }}
    </dd>
  </dl>
</template>
